import React, { Fragment } from 'react'
import { Col, Card, CardBody, Button } from 'reactstrap';
import { useTemplateSurvey } from '../../hooks/templateSurvey/useTemplateSurvey'
import { Dialog } from "primereact/dialog";
import './styleCards.css';
import { ToastAletGlobal } from '../alertDialog/ToastAletGlobal';
import ConsentTemplate from "../../../src/views/consentTemplate/ConsentTemplate";






export const IndexListTemplateSurvey = () => {


    const {
        createSurvey,
        listSurveys,
        handleEditSurvey,
        handleDeleteTemplateSurvey,

        // ?  CONFIGURATION UPDATE STATUS TEMPLATE SURVEY
        handleEnableTemplate,
        handleCloseEnableDialog,
        showEnableDialog,
        loadingStatus,
        handleOpenEnableDialog,


        // ? ALERT
        showToast,
        toastType,
        toastTitle,
        toastMessage,
        closeToastAlert,


        // ?  CONFIGURATION DELETE TEMPLATE SURVEY
        showDeleteDialog,
        handleCloseDeleteDialog,
        templateToDelete,
        loadingDelete,
        handleOpenDeleteDialog,


        // ? PREVIEW SURVEY
        selectedSurvey,
        showSurveyPreview,
        handleOpenSurveyPreview,
        handleCloseSurveyPreview,


        // ? CLAUSES SURVEY
        handleOpenClausesDialog,
        handleCloseClausesDialog,
        templateToClauses,
        loadingClauses,
        showClauses,
        clausesForm,
        handleChangeClause,
        handleSaveClauses



    } = useTemplateSurvey()
    console.log("🚀 ~ IndexListTemplateSurvey ~ templateToClauses:", templateToClauses)





    return (
        <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <div style={{ paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth", transform: "scale(0.9)", width: "111%", transformOrigin: "top left", textAlign: "center", height: "20%" }}>
                <Card style={{
                    marginBottom: '15px',
                    background: 'linear-gradient(135deg, #002940 0%, #1d5b83 100%)',
                    border: 'none',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                }}>
                    <CardBody style={{ padding: '18px 25px' }}>
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                                <div style={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginRight: '15px'
                                }}>
                                    <img alt="flask" className="img-fluid text-info mr-2" src={require("../../assets/images/laboratory-External/survey-img.svg")} style={{ width: "60px", height: "60px" }} />
                                </div>
                                <div>
                                    <h4 className="mb-1" style={{ color: '#fff', fontWeight: 700, fontSize: '20px', textAlign: "justify" }}>
                                        Generador de consentimientos
                                    </h4>
                                    <small style={{ color: 'rgba(255, 255, 255, 0.85)', fontSize: '13px' }}>
                                        <i className="fa fa-info-circle mr-1"></i>
                                        Configuración de preguntas que iran asociadas , para que el paciente conteste en la toma de muestra.
                                    </small>
                                </div>
                            </div>

                        </div>
                    </CardBody>
                </Card>
                {
                    // * CONFIGURATION
                }
                <Card className='shadow-sm border height-equal pricingtable mb-0 pb-0' style={{ paddingTop: "1px", paddingLeft: "5px", paddingRight: "5px", textAlign: "center" }}>
                    <Col sm="12" className="pt-3">

                        <div
                            className="text-right"
                            style={{
                                margin: 5,
                                paddingBottom: 10
                            }}
                        >
                            {Array.isArray(listSurveys) && listSurveys.length > 0


                                && <Button
                                    type="button"
                                    className="card-template-survey-add-button"
                                    onClick={createSurvey}
                                >
                                    <i className="fa fa-plus"></i>

                                    <span>
                                        Nuevo consentimiento
                                    </span>
                                </Button>
                            }


                        </div>

                    </Col>


                    <Col sm="12">

                        {Array.isArray(listSurveys) && listSurveys.length > 0 ? (

                            <div className="card-template-survey-grid">

                                {listSurveys.map((survey) => {

                                    const isDeleted =
                                        survey.id_user_who_deleted !== null &&
                                        survey.id_user_who_deleted !== undefined &&
                                        Number(survey.id_user_who_deleted) !== 0;

                                    return <article
                                        key={survey.id_template}
                                        className={`card-template-survey-card ${survey.is_active
                                            ? "card-template-survey-card-active"
                                            : ""}
                                            ${isDeleted
                                                ? "card-template-survey-card-deleted"
                                                : ""}
                                        `}
                                    >

                                        <div className="card-template-survey-top">

                                            <div className="card-template-survey-icon">
                                                <i className="icofont icofont-picture"></i>
                                            </div>

                                            <div className="card-template-survey-top-right">

                                                <span
                                                    className={`card-template-survey-status ${survey?.is_active
                                                        ? "card-template-survey-status-active"
                                                        : "card-template-survey-status-inactive"}`}
                                                >
                                                    <span className="card-template-survey-status-dot"></span>

                                                    {survey.is_active
                                                        ? "ACTIVA"
                                                        : "INACTIVA"}
                                                </span>

                                                <div className={isDeleted ? "d-none" : "card-template-survey-actions"} >

                                                    {
                                                        !survey.is_active && <button
                                                            type="button"
                                                            className="card-template-survey-action card-template-survey-action-edit"
                                                            title="Editar encuesta"
                                                            onClick={() => handleEditSurvey(survey)}
                                                        >
                                                            <i className="fa fa-pencil"></i>
                                                        </button>
                                                    }


                                                    {
                                                        !survey?.is_active && <button
                                                            type="button"
                                                            className={`card-template-survey-action ${survey.is_active
                                                                ? "card-template-survey-action-enabled"
                                                                : "card-template-survey-action-disabled"
                                                                }`}
                                                            title={
                                                                survey?.is_active
                                                                    ? "Desactivar encuesta"
                                                                    : "Activar formato"
                                                            }
                                                            onClick={() => handleOpenEnableDialog(survey)}
                                                        >
                                                            <i
                                                                className={
                                                                    survey?.is_active
                                                                        ? "fa fa-toggle-on"
                                                                        : "fa fa-toggle-off"
                                                                }
                                                            ></i>
                                                        </button>
                                                    }
                                                    <button
                                                        type="button"
                                                        className="card-template-survey-action card-template-survey-action-delete"
                                                        title="Desactivar encuesta"
                                                        onClick={() => handleOpenDeleteDialog(survey)}

                                                    >
                                                        <i className="fa fa-ban"></i>
                                                    </button>

                                                    <button
                                                        type="button"
                                                        className="card-template-survey-action card-template-survey-action-clauses"
                                                        title="Anexar clausulas"
                                                        onClick={() => handleOpenClausesDialog(survey)}

                                                    >
                                                        <i className="fa fa-file-text-o"></i>
                                                    </button>



                                                </div>

                                            </div>

                                        </div>

                                        <div className="card-template-survey-content pb-3">

                                            <span className="card-template-survey-category">
                                                Consentimiento informado
                                            </span>

                                            <h3
                                                className="card-template-survey-title"
                                                title={survey.title}
                                            >
                                                {survey.title || "Encuesta sin título"}
                                            </h3>

                                        </div>

                                        <div className="card-template-survey-details">

                                            <div className="card-template-survey-detail">

                                                <span className="card-template-survey-detail-icon">
                                                    <i className="fa fa-barcode f-16"></i>
                                                </span>

                                                <div>
                                                    <span className="card-template-survey-detail-label">
                                                        Código
                                                    </span>

                                                    <strong className="card-template-survey-detail-value">
                                                        ENC-{String(
                                                            survey.id_template
                                                        ).padStart(4, "0")}
                                                    </strong>
                                                </div>

                                            </div>

                                            <div className="card-template-survey-detail">

                                                <span className="card-template-survey-detail-icon">
                                                    <i className="fa fa-file-text-o f-16"></i>
                                                </span>

                                                <div>
                                                    <span className="card-template-survey-detail-label">
                                                        Versión
                                                    </span>

                                                    <strong
                                                        className="card-template-survey-detail-value"
                                                        title={survey.version || "1.0"}
                                                    //style={{ cursor: "help" }}
                                                    >
                                                        {
                                                            (survey.version || "1.0").length > 13
                                                                ? `${(survey.version || "1.0").substring(0, 13)}...`
                                                                : (survey.version || "1.0")
                                                        }
                                                    </strong>
                                                </div>

                                            </div>

                                            <div className="card-template-survey-detail">

                                                <span className="card-template-survey-detail-icon">
                                                    <i className="fa fa-question-circle f-16"></i>
                                                </span>

                                                <div>
                                                    <span className="card-template-survey-detail-label">
                                                        Preguntas
                                                    </span>

                                                    <strong className="card-template-survey-detail-value">
                                                        {Array.isArray(survey.questions)
                                                            ? survey.questions.length
                                                            : 0}
                                                    </strong>
                                                </div>

                                            </div>

                                            <div className="card-template-survey-detail card-template-survey-detail-sections">

                                                <div className="card-template-survey-sections-content">

                                                    <span className="card-template-survey-detail-label">
                                                        Secciones
                                                    </span>

                                                    <div className="card-template-survey-sections-list">

                                                        {(survey?.associated_sectionsLabel ?? []).length > 0 ? (
                                                            survey.associated_sectionsLabel.map((section, index) => (
                                                                <span
                                                                    key={index}
                                                                    className="card-template-survey-section-item"
                                                                >
                                                                    <i className="fa fa-circle"></i>
                                                                    {section}
                                                                </span>
                                                            ))
                                                        ) : (
                                                            <span className="card-template-survey-section-empty">
                                                                Sin secciones
                                                            </span>
                                                        )}

                                                    </div>

                                                </div>

                                            </div>

                                        </div>

                                        <div className="card-template-survey-footer">
                                            <button
                                                type="button"
                                                className="card-template-survey-open-button"
                                                onClick={() => handleOpenSurveyPreview(survey)}
                                            >
                                                <span>
                                                    Preview de la encuesta
                                                </span>

                                                <i className="fa fa-arrow-right"></i>
                                            </button>
                                        </div>

                                    </article>;
                                })}

                            </div>

                        ) : (

                            <div className="card-template-survey-empty">

                                <div className="card-template-survey-empty-icon">
                                    <i className="fa fa-file-text-o"></i>
                                </div>

                                <h4>
                                    No hay encuestas registradas
                                </h4>

                                <p>
                                    Cree una nueva encuesta para comenzar.
                                </p>

                                <button
                                    type="button"
                                    className="card-template-survey-empty-button"
                                    onClick={createSurvey}
                                >
                                    <i className="fa fa-plus"></i>
                                    Crear encuesta
                                </button>

                            </div>

                        )}

                    </Col>
                </Card>



            </div>


            {
                // * PREVIEW SURVEY
            }
            <Dialog
                visible={showSurveyPreview}
                onHide={handleCloseSurveyPreview}
                modal
                draggable={false}
                closable={true}
                maskClassName="custom-total-mask"
                header={
                    <div className="seller-dialog-header">
                        <div className="seller-dialog-header__content">

                            <div className="seller-dialog-icon">
                                <i className="icofont icofont-picture f-26"></i>
                            </div>

                            <div>
                                <div className="seller-dialog-title">
                                    Simulador de encuesta
                                </div>
                            </div>
                        </div>
                    </div>
                }
                className="seller-dialog seller-blue seller-xl"


            >

                {
                    // * PREVIEW SURVEY 
                }
                {selectedSurvey && (
                    <ConsentTemplate
                        template={selectedSurvey}
                        onFinish={(result) => {
                            console.log(
                                "Resultado del simulador:",
                                result
                            );

                            handleCloseSurveyPreview();
                        }}

                    />
                )}
            </Dialog>




            {
                // * MODAL SURVEY
            }

            <Dialog
                visible={showEnableDialog}
                onHide={handleCloseEnableDialog}
                modal
                closable={false}
                maskClassName="custom-total-mask"
                header={
                    <div className="seller-dialog-header">
                        <div className="seller-dialog-header__content">

                            <div className="seller-dialog-icon">
                                <i className="fa fa-lock"></i>
                            </div>

                            <div>
                                <div className="seller-dialog-title">
                                    Liberar formato

                                </div>

                                <div className="seller-dialog-subtitle">
                                    Confirmación de publicación
                                </div>
                            </div>

                        </div>
                    </div>
                }
                className="seller-dialog seller-danger seller-small-v"
                footer={
                    <>

                        <Button
                            size="sm"
                            color="secondary"
                            type="button"
                            onClick={handleEnableTemplate}
                            disabled={loadingStatus}
                        >
                            {
                                loadingStatus ? "Activando..." : "Sí, activar"
                            }

                        </Button>

                        <Button
                            size="sm"
                            color="danger"
                            type="button"
                            onClick={handleCloseEnableDialog}
                            disabled={loadingStatus}
                        >
                            Cancelar
                        </Button>
                    </>
                }
            >
                <div className="template-release-dialog">

                    <div className="template-release-dialog__intro">
                        <div className="template-release-dialog__intro-icon">
                            <i className="fa fa-check-circle"></i>
                        </div>

                        <div>
                            <div className="template-release-dialog__intro-title">
                                El formato quedará disponible
                            </div>

                            <p className="template-release-dialog__intro-text">
                                Una vez liberado, el formato podrá ser utilizado por los usuarios correspondientes.
                            </p>
                        </div>
                    </div>

                    <div className="template-release-dialog__warning">
                        <div className="template-release-dialog__warning-icon">
                            <i className="fa fa-exclamation-triangle"></i>
                        </div>

                        <div>
                            <div className="template-release-dialog__warning-title">
                                Esta acción restringirá la edición
                            </div>

                            <p className="template-release-dialog__warning-text">
                                Después de liberar el formato ya no podrá modificar su contenido.
                                Para realizar cambios deberá crear una nueva versión.
                            </p>


                        </div>
                    </div>



                </div>
            </Dialog>


            {
                // * MODAL DELETE SURVEY
            }
            <Dialog
                visible={showDeleteDialog}
                onHide={handleCloseDeleteDialog}
                modal
                closable={false}
                maskClassName="custom-total-mask"
                header={
                    <div className="seller-dialog-header">
                        <div className="seller-dialog-header__content">

                            <div className="seller-dialog-icon">
                                <i className="fa fa-ban"></i>
                            </div>

                            <div>
                                <div className="seller-dialog-title">
                                    Desactivar formato
                                </div>

                                <div className="seller-dialog-subtitle">
                                    {templateToDelete?.title || "Sin nombre"}

                                </div>
                            </div>

                        </div>
                    </div>
                }
                className="seller-dialog seller-danger seller-small-v"
                footer={
                    <>
                        <Button
                            size="sm"
                            color="danger"
                            type="button"
                            onClick={handleDeleteTemplateSurvey}
                            disabled={loadingDelete}
                        >
                            {
                                loadingDelete
                                    ? "Desactivando..."
                                    : "Sí, desactivar"
                            }
                        </Button>

                        <Button
                            size="sm"
                            color="secondary"
                            type="button"
                            onClick={handleCloseDeleteDialog}
                            disabled={loadingDelete}
                        >
                            Cancelar
                        </Button>
                    </>
                }
            >
                <div className="template-delete-dialog">



                    <div className="template-delete-dialog__warning">
                        <div className="template-delete-dialog__warning-icon">
                            <i className="fa fa-exclamation-triangle"></i>
                        </div>

                        <div>
                            <div className="template-delete-dialog__warning-title">
                                ¿Está seguro de desactivar este formato?
                            </div>

                            <p className="template-delete-dialog__warning-text">
                                El formato dejará de estar disponible para los usuarios.
                                Esta acción también desactivará sus preguntas y opciones
                                relacionadas.
                            </p>
                        </div>
                    </div>

                    <div className="template-delete-dialog__note">
                        <i className="fa fa-info-circle"></i>

                        <span>
                            El registro no se eliminará permanentemente; solo estara inactivo para la toma de muestra.
                        </span>
                    </div>

                </div>
            </Dialog>


            {
                // * MODAL CLAUSES SURVEY
            }
            <Dialog
                visible={showClauses}
                onHide={handleCloseClausesDialog}
                modal
                closable={false}
                maskClassName="custom-total-mask"
                header={
                    <div className="seller-dialog-header">
                        <div className="seller-dialog-header__content">

                            <div className="seller-dialog-icon">
                                <i className="fa fa-file-text-o"></i>
                            </div>

                            <div>
                                <div className="seller-dialog-title">
                                    Anexar Clausulas
                                </div>

                                <div className="seller-dialog-subtitle">
                                    {templateToClauses?.title || "Sin nombre"}

                                </div>
                            </div>

                        </div>
                    </div>
                }
                className="seller-dialog seller-blue seller-xl"
                footer={
                    <>
                        <Button
                            size="sm"
                            color="secondary"
                            type="button"
                            onClick={handleSaveClauses}
                            disabled={loadingClauses}
                        >
                            {
                                loadingClauses
                                    ? "Guardando..."
                                    : "Guardar"
                            }
                        </Button>

                        <Button
                            size="sm"
                            color="danger"
                            type="button"
                            onClick={handleCloseClausesDialog}
                            disabled={loadingClauses}
                        >
                            Cancelar
                        </Button>

                    </>
                }


            >


                <div className="survey-sampling-clauses-container">
                    <div className="survey-sampling-clause-card">

                        <div className="survey-sampling-clause-header">

                            <div className="survey-sampling-clause-number">
                                1
                            </div>

                            <div>

                                <div className="survey-sampling-clause-title">
                                    Cláusula principal
                                </div>

                                <div className="survey-sampling-clause-subtitle">
                                    Agrega alguna observación, condición o texto adicional.
                                </div>

                            </div>

                        </div>


                        <div className="survey-sampling-clause-body">

                            <textarea
                                className="survey-sampling-clause-textarea"
                                rows={6}
                                maxLength={1500}
                                value={clausesForm.clauses_1}
                                onChange={(e) =>
                                    handleChangeClause(
                                        "clauses_1",
                                        e.target.value
                                    )
                                }
                                placeholder="Escribe aquí la primera cláusula u observación..."
                            />

                            <div className="survey-sampling-clause-counter">
                                {clausesForm.clauses_1.length} / 1500
                            </div>

                        </div>

                    </div>


                    <div className="survey-sampling-clause-card">

                        <div className="survey-sampling-clause-header">

                            <div className="survey-sampling-clause-number">
                                2
                            </div>

                            <div>

                                <div className="survey-sampling-clause-title">
                                    Cláusula adicional
                                </div>

                                <div className="survey-sampling-clause-subtitle">
                                    Este campo es opcional.
                                </div>

                            </div>

                        </div>


                        <div className="survey-sampling-clause-body">

                            <textarea
                                className="survey-sampling-clause-textarea"
                                rows={6}
                                maxLength={1500}
                                value={clausesForm.clauses_2}
                                onChange={(e) =>
                                    handleChangeClause(
                                        "clauses_2",
                                        e.target.value
                                    )
                                }
                                placeholder="Escribe aquí una segunda cláusula u observación..."
                            />

                            <div className="survey-sampling-clause-counter">
                                {clausesForm.clauses_2.length} / 1500
                            </div>

                        </div>

                    </div>

                </div>

            </Dialog>


            {
                // * TOST ALERT
            }

            <ToastAletGlobal
                visible={showToast}
                type={toastType}
                title={toastTitle}
                message={toastMessage}
                onClose={closeToastAlert}
            />













        </div>
    )
}
